export enum CountryIdEnum {
    Russia = 1,
    Belarus = 4,
}
